import { render, staticRenderFns } from "./GoLive.vue?vue&type=template&id=1ea168d0&scoped=true&"
import script from "./GoLive.vue?vue&type=script&lang=js&"
export * from "./GoLive.vue?vue&type=script&lang=js&"
import style0 from "./GoLive.vue?vue&type=style&index=0&id=1ea168d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea168d0",
  null
  
)

export default component.exports